import styled from "styled-components"

const InlineButton = styled.button.attrs(props => ({
  type: props.type
}))`
  color: #428bca;
  border: none;
  background: none;
  line-height: 1;
  border-bottom: 1px solid #428bca;
  cursor: pointer;
  padding: 0px;
`

export default InlineButton
